// components/inventory/StockCard.tsx
import { useAppTheme } from "@/hooks/useAppTheme";
import { useAppDispatch } from "@/store/hooks";
import { deleteStockEntry } from "@/store/slices/stockSlice";
import { Ionicons } from "@expo/vector-icons";
import { router } from "expo-router";
import { Alert, StyleSheet, Text, TouchableOpacity, View } from "react-native";

export default function StockCard({ entry, onRefresh }: any) {
  const { colors, spacing } = useAppTheme();
  const dispatch = useAppDispatch();
  // API type is lowercase 'in' or 'out'
  const isIn = entry.type === "in";
  // product name comes from nested Product object
  const productName = entry.Product?.name || `Product ID: ${entry.productId}`;

  const handleDelete = () => {
    Alert.alert("Delete", `Delete this stock entry?`, [
      { text: "Cancel", style: "cancel" },
      {
        text: "Delete",
        style: "destructive",
        onPress: async () => {
          const result = await dispatch(deleteStockEntry(entry.id));
          if (deleteStockEntry.fulfilled.match(result)) onRefresh();
        },
      },
    ]);
  };

  const styles = StyleSheet.create({
    card: {
      backgroundColor: colors.background,
      borderRadius: 12,
      padding: spacing.md,
      marginBottom: spacing.md,
      borderWidth: 1,
      borderColor: colors.border,
    },
    header: { flexDirection: "row", justifyContent: "space-between" },
    productName: { fontSize: 16, fontWeight: "600", color: colors.text },
    date: { fontSize: 12, color: colors.textLight, marginTop: 2 },
    quantity: {
      fontSize: 18,
      fontWeight: "bold",
      marginTop: 4,
      color: isIn ? "#22c55e" : "#ef4444",
    },
    reason: { fontSize: 14, color: colors.textLight, marginTop: 4 },
    actions: {
      flexDirection: "row",
      marginTop: spacing.md,
      paddingTop: spacing.sm,
      borderTopWidth: 1,
      borderTopColor: colors.border,
      justifyContent: "flex-end",
    },
    actionButton: {
      paddingHorizontal: spacing.md,
      paddingVertical: 6,
      flexDirection: "row",
      alignItems: "center",
    },
  });

  return (
    <View style={styles.card}>
      <View style={styles.header}>
        <View>
          <Text style={styles.productName}>{productName}</Text>
          <Text style={styles.date}>
            {new Date(entry.createdAt).toLocaleString()}
          </Text>
        </View>
        <TouchableOpacity
          onPress={() => router.push(`/(app)/inventory/stock/${entry.id}`)}
        >
          <Ionicons name="chevron-forward" size={20} color={colors.textLight} />
        </TouchableOpacity>
      </View>
      <Text style={styles.quantity}>
        {isIn ? `+${entry.quantity}` : `-${entry.quantity}`}
      </Text>
      <Text style={styles.reason}>{entry.reason}</Text>
      {/* <View style={styles.actions}>
        <TouchableOpacity
          style={styles.actionButton}
          onPress={() => router.push(`/(app)/inventory/stock/${entry.id}`)}
        >
          <Ionicons name="create-outline" size={18} color={colors.primary} />
          <Text style={{ marginLeft: 4, color: colors.textLight }}>
            Details
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          disabled
          style={styles.actionButton}
          onPress={handleDelete}
        >
          <Ionicons name="trash-outline" size={18} color={colors.danger} />
          <Text style={{ marginLeft: 4, color: colors.danger }}>Delete</Text>
        </TouchableOpacity>
      </View> */}
    </View>
  );
}
